import { Component, Input } from "@angular/core";
import { Actionnaire } from "../../../interfaces/Actionnaire";

@Component({
  selector: "app-informations",
  templateUrl: "./informations.component.html",
  standalone: false,
})
export class InformationsComponent {
  @Input() actionnaire: Actionnaire;

  onAdministreChange(event: any): void {
    if (event.checked) {
      this.actionnaire.actionnaire_ModeReg = 1;
    }
  }
}
